import { lazy } from 'react';
import { routerMain } from 'constants/routerMain';
import { routerPathMain } from 'constants/routerPathMain';

// * văn bản
const CategorySubmission = lazy(() => import('features/category-submission/pages/CategorySubmission'));
const CategorySubmissionAdd = lazy(() => import('features/category-submission/pages/CategorySubmissionAdd'));
const BatchSignerAdd = lazy(() => import('features/category-submission/pages/BatchSignerAdd'));
const CategorySubmissionEdit = lazy(() => import('features/category-submission/pages/CategorySubmissionEdit'));
const CategorySubmissionNumberedText = lazy(() =>
    import('features/category-submission/pages/numbered-text/CategorySubmissionNumberedText')
);
const CategorySubmissionPosition = lazy(() =>
    import('features/category-submission/pages/pdf-submission/CategorySubmissionPosition')
);
const CategorySubmissionViewEnd = lazy(() =>
    import('features/category-submission/pages/submission-view/CategorySubmissionViewEnd')
);
const CategorySubmissionView = lazy(() =>
    import('features/category-submission/pages/submission-view/CategorySubmissionView')
);
const CategorySubmissionConfirm = lazy(() =>
    import('features/category-submission-confirm/pages/CategorySubmissionConfirm')
);
const CategorySubmissionConfirmView = lazy(() =>
    import('features/category-submission-confirm/pages/CategorySubmissionConfirmView')
);
const CategorySubmissionStopEffect = lazy(() =>
    import('features/category-submission/pages/stop-effect/CategorySubmissionStopEffect')
);
const BatchSignerEdit = lazy(() => import('features/category-submission/pages/BatchSignerEdit'));
const CategorySubmissionFileTemplatePosition = lazy(() =>
    import('features/category-submission/pages/pdf-submission/CategorySubmissionFileTemplatePosition')
);
const CategorySubmissionFileTemplateView = lazy(() =>
    import('features/category-submission/pages/submission-view/CategorySubmissionFileTemplateView')
);
const CategorySubmissionFileTemplateViewEnd = lazy(() =>
    import('features/category-submission/pages/submission-view/CategorySubmissionFileTemplateViewEnd')
);

const CategorySubmissionConfirmed = lazy(() =>
    import('features/category-submission-confirmed/pages/CategorySubmissionConfirmed')
);
const CategorySubmissionConfirmedView = lazy(() =>
    import('features/category-submission-confirmed/pages/CategorySubmissionConfirmedView')
);
const CategoryRefuse = lazy(() => import('features/category-refuse/pages/CategoryRefuse'));
const CategoryRefuseView = lazy(() => import('features/category-refuse/pages/CategoryRefuseView'));
const CategoryQuickSubmissionAdd = lazy(() => import('features/category-quick-submission/CategoryQuickSubmissionAdd'));
const CategoryQuickSubmissionEdit = lazy(() =>
    import('features/category-quick-submission/CategoryQuickSubmissionEdit')
);

const SubmissionRouter = [
    {
        path: routerMain.CATEGORY_SUBMISSION,
        exact: true,
        component: CategorySubmission,
    },
    {
        path: routerMain.CATEGORY_SUBMISSION,
        exact: true,
        component: CategorySubmission,
        // redirect_path: routerMain.CATEGORY_SUBMISSION
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.ADD}`,
        exact: true,
        component: CategorySubmissionAdd,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.EDIT}/:uuid`,
        exact: true,
        component: CategorySubmissionEdit,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.ADD}${routerPathMain.POSITION}/:uuid`,
        exact: true,
        component: CategorySubmissionPosition,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.BATCH_SIGNER_VIEW}/:uuid`,
        exact: true,
        component: CategorySubmissionFileTemplateView,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.BATCH_SIGNER_ADD}`,
        exact: true,
        component: BatchSignerAdd,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.BATCH_SIGNER_ADD}${routerPathMain.END}/:uuid`,
        exact: true,
        component: CategorySubmissionFileTemplateViewEnd,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.BATCH_SIGNER_EDIT}/:uuid`,
        exact: true,
        component: BatchSignerEdit,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.BATCH_SIGNER_ADD}${routerPathMain.POSITION}/:uuid`,
        exact: true,
        component: CategorySubmissionFileTemplatePosition,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.BATCH_SIGNER_EDIT}${routerPathMain.POSITION}/:uuid`,
        exact: true,
        component: CategorySubmissionFileTemplatePosition,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.BATCH_SIGNER_EDIT}${routerPathMain.END}/:uuid`,
        exact: true,
        component: CategorySubmissionFileTemplateViewEnd,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.EDIT}${routerPathMain.POSITION}/:uuid`,
        exact: true,
        component: CategorySubmissionPosition,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.ADD}${routerPathMain.NUMBERED}/:uuid`,
        exact: true,
        component: CategorySubmissionNumberedText,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.EDIT}${routerPathMain.NUMBERED}/:uuid`,
        exact: true,
        component: CategorySubmissionNumberedText,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.ADD}${routerPathMain.END}/:uuid`,
        exact: true,
        component: CategorySubmissionViewEnd,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.EDIT}${routerPathMain.END}/:uuid`,
        exact: true,
        component: CategorySubmissionViewEnd,
    },

    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: CategorySubmissionView,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.STOP_EFFECT}/:uuid`,
        exact: true,
        component: CategorySubmissionStopEffect,
    },
    {
        path: routerMain.CATEGORY_SUBMISSION_CONFIRM,
        exact: true,
        component: CategorySubmissionConfirm,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION_CONFIRM}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: CategorySubmissionConfirmView,
    },
    {
        path: routerMain.CATEGORY_SUBMISSION_CONFIRMED,
        exact: true,
        component: CategorySubmissionConfirmed,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION_CONFIRMED}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: CategorySubmissionConfirmedView,
    },
    {
        path: routerMain.CATEGORY_SUBMISSION_REFUSE,
        exact: true,
        component: CategoryRefuse,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION_REFUSE}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: CategoryRefuseView,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.QUICK_SIGNER_ADD}`,
        exact: true,
        component: CategoryQuickSubmissionAdd,
    },
    {
        path: `${routerMain.CATEGORY_SUBMISSION}${routerPathMain.QUICK_SIGNER_EDIT}/:uuid`,
        exact: true,
        component: CategoryQuickSubmissionEdit,
    },
];
export default SubmissionRouter;
